import React, { useState } from 'react';
import Counter from './Counter';
import UserProfile from './UserProfile';
import TodoList from './TodoList';
import ExampleComponent from './ExampleComponent';
import TimerComponent from './TimerComponent';
import Clock from './Clock';
import UserProfileClass from './UserProfileClass';
import UserComponent from './UserComponent';
function App() {
	const user = {
		name: "Alice Wonderland",
		email: "alice@example.com",
		imageUrl: "http://example.com/alice.jpg"
};	
	const handleEdit = () => {
		// Implementation for toggling edit mode could go here
		console.log("Edit mode activated");
	};
	return(
		<div>
			<Counter />
            <UserProfile userID="1"/>
            <TodoList />
            <ExampleComponent />
            <TimerComponent />
            <Clock />
            <UserProfileClass userID="2" />
            <UserComponent userID="3" />
		</div>
	) 
}
export default App